import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { ChevronToggle } from '../ChevronToggle';

import './_styles.scss';

import { TRIAL_DISABLED_USERS } from '@/utils/constants/home';
import { _remainingTimeInTrial } from '@/utils/ts/stringUtils';

export default function TrialBanner() {
  const [rotate, setRotate] = useState(true);
  const { userDetails } = useSelector((state) => state.user);

  const location = useLocation();

  const shouldBannerDisplay =
    userDetails?.accountVersion === 'v2' &&
    userDetails?.subscriptionStatus === 'trial' &&
    !TRIAL_DISABLED_USERS.includes(userDetails?._id);

  const showShowRotate = location?.pathname === '/dashboard';

  const getRemainingTimeForTrial = _remainingTimeInTrial(userDetails?.freeTrialEnd);
  const fullForm = getRemainingTimeForTrial?.fullForm;
  const shortForm = getRemainingTimeForTrial?.shortForm;

  useEffect(() => {
    if (!showShowRotate) {
      setRotate(false);
    }
  }, [location.pathname]);

  return (
    shouldBannerDisplay && (
      <div className="trial-days-banner">
        {rotate ? (
          <div className="trial-banner-container" onClick={() => setRotate(!rotate)}>
            <div className="trial-banner-content text-sm">
              ⏳ <span className="text-default mr-1">{fullForm}</span> left in trial.
              <span className="ml-1">Make the most of it!</span>
            </div>
            <div className="trial-banner-close-button">
              <ChevronToggle toggle={true} width={24} height={24} />
            </div>
          </div>
        ) : (
          <div className="trial-banner-content-collapsed">
            <div
              className="trial-banner-content"
              onClick={() => {
                if (showShowRotate) {
                  setRotate(!rotate);
                }
              }}>
              <p className="text-sm">{shortForm} Trial</p>
              {showShowRotate && <ChevronToggle toggle={false} width={24} height={24} />}
            </div>
          </div>
        )}
      </div>
    )
  );
}
